import "./SurveyHeaderComponent.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import { SurveyDetailsBarInfo, detailsBarText } from "@teams/cards";
import { SurveyDTO } from "@teams/types/api";
import React from "react";

type Props = {
  survey: SurveyDTO;
};

export const SurveyHeaderComponent: React.FC<Props> = ({ survey }) => {
  return (
    <div>
      <Flex className="surveyHeader" vAlign="start">
        <Flex.Item grow={1}>
          <div>
            <Text
              className="surveyHeader__title"
              content={survey.title}
              size="large"
              weight="bold"
              as="div"
            />
          </div>
        </Flex.Item>
      </Flex>
      <Text
        className="surveyHeader__details"
        size="small"
        color="grey 450"
        content={detailsBarText(survey as SurveyDetailsBarInfo, { activeCardDateFormat: false })}
      />
    </div>
  );
};
